import { render, staticRenderFns } from "./rh_redefinir.vue?vue&type=template&id=5aa7aab4&"
import script from "./rh_redefinir.vue?vue&type=script&lang=js&"
export * from "./rh_redefinir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports